import { render, staticRenderFns } from "./AddBalance.vue?vue&type=template&id=1764809c&"
import script from "./AddBalance.vue?vue&type=script&lang=js&"
export * from "./AddBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports